'use client';

import React, { useState } from 'react';
import GallerySection from './GallerySection';
import { ImageType } from '@/utils/common.types';

interface Props {
  title: string;
  galleryContent: {
    __typename: string;
    title?: string;
    category?: string;
    brandLogo?: ImageType;
    video?: {
      id: string;
      host: string;
    };
    image?: {
      desktop?: ImageType;
      mobile?: ImageType;
    };
    button?: {
      label: string;
      url: string;
      isRelative: boolean;
      isOpenNewWindow: boolean;
    };
  }[];
  includeCardTitles: boolean;
}

const ContentGallery = ({
  title,
  galleryContent = [],
  includeCardTitles,
}: Props) => {
  const [galleryIndex, setGalleryIndex] = useState(1);
  const galleryData: Props['galleryContent'][] = [];

  // Split Gallery Data into max sections of 5 (largest grid size)
  for (let i = 0; i < galleryContent.length; i += 5) {
    const splitGalleryContent = galleryContent.slice(i, i + 5);
    galleryData.push(splitGalleryContent);
  }

  return (
    <section
      className="mx-auto my-[40px] w-[86%] md:max-w-standard"
      id="Gallery"
    >
      <h2 className="mb-[30px] text-[22px] font-bold text-hbg-blue md:text-[26px] lg:text-[35px]">
        {title}
      </h2>
      {galleryContent.length > 0 && (
        <>
          <div className="gallery">
            {galleryData &&
              galleryData.slice(0, galleryIndex).map((section, key) => {
                return (
                  <GallerySection
                    sectionContent={section}
                    isLeft={(key + 1) % 2 === 1}
                    includeCardTitles={includeCardTitles}
                    key={key}
                  />
                );
              })}
          </div>
          <div>
            {galleryIndex < galleryData.length && (
              <button
                className="flex w-full cursor-pointer justify-around border border-solid border-clayton-blue bg-transparent px-[30px] py-[17px] text-[14px] font-semibold uppercase text-clayton-blue"
                onClick={(e) => {
                  e.preventDefault();
                  setGalleryIndex(galleryIndex + 1);
                }}
              >
                Load More
              </button>
            )}
          </div>
        </>
      )}
    </section>
  );
};

export default ContentGallery;
